import { CompetitionData, CompetitionFeeApplicable, CompetitionMatch, PlainScoreCard, PlayerData } from 'src/data/mygolf.data';
import { Component, Input, OnInit, Sanitizer, ViewEncapsulation } from '@angular/core';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { JsonService } from 'src/json-util';
import { Subscription } from 'rxjs';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { MessageDisplayUtil } from 'src/message-display-utils';

export class ExtraOptionCheckbox {
  checked?: boolean;
  id?: string;
  name?: string;
}

export class PullupMenuData {
  id?: string;
  name?: string;
  shortName?: string;
  iconUrl?: string;
  data?: any;
  disabled?: boolean;
}

export class MessageData {
  title?: string;
  content?: string;
}
/***
 @param dataList - list of items to display in structure of
 * {
  id?: string;
  name?: string;
  shortName?: string;
  iconUrl?: string;
 * }
  @param headerTitle - string
  @param mode - default common | scoringCompetition | singleSelection | infoDisplay | dualOptions | messageSuccess
  @param selectedValue - string
 *
 */
@Component({
  selector: 'app-common-pullup-menu',
  templateUrl: './common-pullup-menu.component.html',
  styleUrls: ['./common-pullup-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CommonPullupMenuComponent implements OnInit {

  @Input() app:any;
  @Input() dataList: Array<PullupMenuData>;
  @Input() headerTitle: string;
  @Input() subTitle: string;
  @Input() mode: string = 'common';
  @Input() message: MessageData;
  @Input() showConfirmBtn: boolean = true;
  @Input() showCancelBtn: boolean = true;
  @Input() showCloseBtn: boolean = true;


  @Input() header: string = 'Confirm';
  @Input() yesText: string = 'Yes';
  @Input() noText: string = 'No';
  @Input() confirmMessage: string = 'Are you sure you want to proceed ?'
  @Input() scorecard: PlainScoreCard;
  @Input() buggyNo: string;

  @Input() firstBtnTxt: string = '';
  @Input() secondBtnTxt: string = '';
  @Input() selectedValue: string = '';
  @Input() quickPlayerType: string = 'mygolf2u'; // mygolf2u || clubMember
  @Input() searchQuickPlayer: string = '';
  @Input() dataId: any;
  @Input() exclusionList: Array<any>;
  resultQuickPlayers: any;
  selectedItem: any;

  @Input() extraCheckboxOption: ExtraOptionCheckbox;
  @Input() membershipNo: string;
  @Input() inputRequired: boolean = false;

  @Input() competitionFeeApplicable: CompetitionFeeApplicable;
  @Input() competitionData: CompetitionData;

  @Input() mainBtnColor: string = null;
  @Input() playerMatch: CompetitionMatch;
  constructor(
    private mdlCtrl : ModalController,
    private flightService: ClubFlightService,
    private mg2uUtils: mygolfUtils,
    private platform: Platform,
    private toastCtl: ToastController,
  ) {
    console.debug("init common pullup [0] : ", this.dataList);
  }

  ngOnInit() {
    console.debug("init common pullup [1] : ", this.dataList);
    console.debug("init common pullup [2] mode : ", this.mode);
    console.debug("init common pullup [3] message : ", this.message);
    console.debug("init common pullup [4] firstBtnTxt : ", this.firstBtnTxt);
    console.debug("init common pullup [5] secondBtnTxt : ", this.secondBtnTxt);
  }

  onClick(data: PullupMenuData){
    if(data?.disabled !== undefined && data?.disabled) return;
    if(data?.id === this.selectedValue) return;
    this.mdlCtrl.dismiss(data);
  }

  onClickCancel(){
    this.mdlCtrl.dismiss();
  }

  onClickConfirm() {
    this.mdlCtrl.dismiss(true);
  }

  onClickDual(type) {
    this.mdlCtrl.dismiss(type);
  }

  onClickApply() {
    if(!this.selectedItem) return;
    let _selectedData = this.dataList.find((item)=>{ return item.id === this.selectedItem})
    this.mdlCtrl.dismiss(_selectedData);
  }

  subSearchQuickPlayer: Subscription;
  refresher: boolean = false;
  onClickSearchQuickPlayer() {
    if(this.subSearchQuickPlayer) return;
    if(!this.searchQuickPlayer) return;
    if(!this.dataId) return;
    // if(this.quickPlayerType === 'clubMember' && this.searchQuickPlayer.length < 3) return;
    this.refresher = true;
    let _searchBy = this.searchQuickPlayer?.toLowerCase();
    this.resultQuickPlayers = [];
    if(this.quickPlayerType === 'mygolf2u') {
      this.flightService.getPlayerById(Number(_searchBy)).subscribe((player: PlayerData) => {
        if(player) {
          JsonService.deriveFulImageURL(player, 'profile');
          JsonService.deriveFulImageURL(player, 'image');
          this.resultQuickPlayers.push(player);
          if(this.exclusionList?.length) {
            this.resultQuickPlayers = this.mg2uUtils.filterExcludeExistingIds(this.resultQuickPlayers, this.exclusionList, 'id')
            // this.resultQuickPlayers = this.resultQuickPlayers.filter((p: PlayerData)=>{
            //   return p.id !==
            // })
          }
        }
        if(this.subSearchQuickPlayer) {
          this.subSearchQuickPlayer.unsubscribe();
          this.subSearchQuickPlayer = null;
        }
        this.refresher = false;
      }, (error)=>{
        if(this.subSearchQuickPlayer) {
          this.subSearchQuickPlayer.unsubscribe();
          this.subSearchQuickPlayer = null;
        }
        this.refresher = false;
      })
    } else if(this.quickPlayerType === 'clubMember') {
      this.flightService.searchPlayerByMembership(_searchBy, this.dataId)
      .subscribe((players: Array < PlayerData > ) => {
        if(players?.length) {
          // players.forEach((p: PlayerData)=>{
          //   JsonService.deriveFulImageURL(p, 'profile');
          //   JsonService.deriveFulImageURL(p, 'image');
          // })
          this.resultQuickPlayers = players.filter((p: PlayerData)=>{ return p.status === 'Active'});
          if(this.exclusionList?.length) {
            this.resultQuickPlayers = this.mg2uUtils.filterExcludeExistingIds(this.resultQuickPlayers, this.exclusionList, 'id')
            // this.resultQuickPlayers = this.resultQuickPlayers.filter((p: PlayerData)=>{
            //   return p.id !==
            // })
          }
        }

        if(this.subSearchQuickPlayer) {
          this.subSearchQuickPlayer.unsubscribe();
          this.subSearchQuickPlayer = null;
        }
        this.refresher = false;
      },(error)=>{
        if(this.subSearchQuickPlayer) {
          this.subSearchQuickPlayer.unsubscribe();
          this.subSearchQuickPlayer = null;
        }
        this.refresher = false;
      });
    }
  }

  getPlayerImage(player: PlayerData) {
    if(!player) return;
    // console.debug("get player image : ", player)
    if(player?.profile) return player?.profile;
    else if(player?.image) return player?.image;
    else return;
  }

  onChangeQuickPlayerType(event) {
    console.debug("change quick player type : ", this.quickPlayerType, event)
    this.searchQuickPlayer = '';
    this.resultQuickPlayers = [];
    // this.onClickSearchQuickPlayer();
  }

  onSelectQuickPlayer(player) {
    if(!player) return;
    let _selectedPlayer = [];
    // _selectedPlayer.push(player);

    var obj = {
      group: false,
      item: player,
      isCovid: true,
      newPlayer: false,
      playerDetails: player,
      playerContact: '',
      availableBalance: 0,
    }
    _selectedPlayer.push(obj);
    this.mdlCtrl.dismiss({
      playerList: _selectedPlayer
    });
  }

  getFilteredExclusionList() {
    let _filtered = [];
    if(this.exclusionList?.length) {
      _filtered = this.exclusionList.filter((p: any)=>{
        if(this.quickPlayerType === 'clubMember') {
          // console.debug("filter exclusion : ", p?.membership, p?.membership?.membershipNo, this.searchQuickPlayer)
          return p?.membership?.membershipNo.toLowerCase() ===  this.searchQuickPlayer.toLowerCase()
        } else {
          return p?.id === Number(this.searchQuickPlayer)
        }
      })
    }
    return _filtered;
  }

  onClickCompRegister(type) {
    console.debug("on click comp register", type, this.inputRequired, this.membershipNo )
    if(this.inputRequired && this.extraCheckboxOption?.checked && (this.membershipNo === undefined || this.membershipNo?.length === 0)) {
      MessageDisplayUtil.showErrorToast('Please enter membership number', this.platform, this.toastCtl, 5000, 'bottom');
      return;
    }
    this.mdlCtrl.dismiss({
      type: type,
      extraCheckboxOption: this.extraCheckboxOption,
      membershipNo: this.membershipNo
    });
  }

  getAmountToPay() {
    let _currency = this.competitionFeeApplicable?.currencySymbol;
    let _amountToPay = 0;
    if(this.extraCheckboxOption?.checked) {
      _amountToPay = this.competitionData?.tournamentFeeClubMember;
    } else if(this.competitionFeeApplicable?.applicableFee) {
      _amountToPay = this.competitionFeeApplicable?.applicableFee;
    } else {
      _amountToPay = this.competitionData?.tournamentFee;
    }

    return _currency + ' ' + _amountToPay;
  }

}
